import { Space, Typography, Form } from 'antd';
import styled from 'styled-components';

export const StretchedSpace = styled(Space)`
  display: flex;
`;

export const SpacedText = styled(Typography.Text)`
  display: inline-block;
  padding-top: 16px;
  padding-bottom: 16px;
`;

export const StretchedFormItem = styled(Form.Item)`
  max-width: 550px;
`;
